import LessonsShow from '@views/lessons/show.vue';

export default [
  {
    path: '/lessons/:lessonId/:flashcardId?',
    name: 'lessons#show',
    component: LessonsShow,
  },
  {
    path: '/lesson-results/:lessonId/',
    name: 'lessons#results',
    component: () => import('@views/lessons/results'),
  },
  {
    path: '/lesson-review/:lessonId/:flashcardId?',
    name: 'lessons#question-review',
    component: () => import('@views/lessons/question-review'),
  },
];
